<template>
    <div class="contract_wrap">
        <!--  合同信息  -->
        <div v-if="arrContractList.length > 1" class="contract_box">
            <template v-for="(item,index) in arrContractList">
                <div :class="{'contract_item':true, 'line_not':index + 1 == arrContractList.length}">
                    <div class="contract_title">
                        {{ item.time }} {{ item.text }}
                    </div>
                    <!-- 变更的合同 -->
                    <template v-if="item.type == 'change'">
                        <div class="look_record" @click="touchLookRecord(item)">查看变更记录</div>
                    </template>
                    <!--                    item.type == 'contract' ||-->

                    <template v-if="item.type == 'contract'">
                        <div class="contract_info">
                            <div class="contract_head red_head">
                                <p>正式合同</p>
                                <div :class="{'contart_state':true,
                                              'green_state':item.status == 1 || item.status == 3,
                                              'orange_state':item.status == 2,
                                              'red_state':item.status == 4 || item.status == 5} ">
                                    {{ item.new_approvalstatus }}
                                </div>
                            </div>
                            <div class="contract_msg_box flex aic" @click="touchContract(item)">
                                <div class="contract_msg">
                                    <p>合同编号：{{ item.new_code || '--' }}</p>
                                    <p>项目类型：{{ item.new_projecttype || '--' }}</p>
                                    <p>合同金额：{{ item.money || '--' }}</p>
                                    <p>审批时间：{{ item.intactTime ? item.intactTime : '暂无' }}</p>
                                </div>
                                <img src="~@/assets/images/archives/dossier/arrow_icon.png" alt="">
                            </div>
                        </div>
                    </template>
                    <template v-if="item.type == 'change'">
                        <div class="contract_info">
                            <div class="contract_head orange_head">
                                <p>变更项目</p>
                                <div :class="{'contart_state':true,
                                              'green_state':item.status == 1 || item.status == 3,
                                              'orange_state':item.status == 2,
                                              'red_state':item.status == 4 || item.status == 5} ">
                                    {{ item.new_approvalstatus }}
                                </div>
                            </div>
                            <div class="contract_msg_box flex aic" @click="touchContract(item)">
                                <div class="contract_msg">
                                    <p>变更原因：{{ item.new_reason }}</p>
                                    <p>变更描述：{{ item.new_memo }}</p>
                                    <p>创建时间：{{ item.intactTime ? item.intactTime : '--' }}</p>
                                    <p class="red_msg">变更后项目类型：{{ item.new_projecttype }}</p>
                                    <p class="red_msg">变更后合同金额：{{ item.money }}</p>
                                </div>
                                <img src="~@/assets/images/archives/dossier/arrow_icon.png" alt="">
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </div>
        <div v-else class="contract_not">
            <img class="contract_not_img" src="~@/assets/images/archives/dossier/contract_not.png" alt="">
            <p>暂无信息</p>
            <div v-if="false" class="add_btn flex aic juc" @click="touchAdd">
                <img src="~@/assets/images/archives/dossier/add_icon2.png" alt="">
                创建合同
            </div>
        </div>
        <div class="bottom_btns flex aic jue">
<!--            <button>动销上报</button>-->
        </div>
    </div>
</template>

<script>

import {getContractList} from "@/js/archives/dossier.js";

export default {
    name: "Contract",
    components: {},
    data() {
        return {
            reate: 2.5,
            arrContractList: []
        }
    },
    mounted() {
        this.getContractListFun();
    },
    methods: {
        getContractListFun() {
            this.$store.commit("loadSwitch", true);

            getContractList({
                contract_id: this.$route.query.contract_id,
                project_id: this.$route.query.project_id
            }).then((res) => {
                console.log('getContractList', res.data.data.result);
                let arrList = res.data.data.result
                arrList.forEach((item) => {
                    if(item.time){
                        let time = item.time;
                        item.time = time.split(' ')[0].replaceAll('-', '/');
                        item.intactTime = time.replaceAll('-', '.');
                    }
                })
                this.arrContractList = arrList;
                this.$store.commit("loadSwitch", false);
            })
        },
        touchAdd() {
        },
        touchContract(item) {
            // type contract - 合同， change - 变更单
            this.$router.push({
                path: `/archives/contract`,
                query: {type: item.type, contract_id: item.contract_id || '', change_id: item.change_id || ''}
            })
        },
        touchLookRecord(item) {
            this.$router.push({
                path: `/archives/contract/record`,
                query: {contract_id: item.contract_id || '', change_id: item.change_id || ''}
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
}

.aic {
    align-items: center;
}

.aie {
    align-items: flex-end;
}

.juc {
    justify-content: center;
}

.jue {
    justify-content: flex-end;
}

.jusb {
    justify-content: space-between;
}

.fw {
    flex-wrap: wrap;
}

.fnw {
    flex-wrap: nowrap;
}

.contract_wrap {
    width: 100%;
    background: #FFFFFF;
    padding: 32px 0 0;
    margin-bottom: calc(128px + env(safe-area-inset-bottom));

    .contract_box {
        width: 100%;
        padding: 48px 32px 0;
        position: relative;

        .contract_item {
            position: relative;
            z-index: 10;
            padding-bottom: 80px;

            .contract_title {
                position: relative;
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #3D3C4F;
                line-height: 34px;
                padding-left: 48px;
            }

            .look_record {
                position: absolute;
                top: 0;
                right: 0;

                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #0D53FC;
                line-height: 34px;
                border-bottom: 1px solid #0D53FC;
            }

            .contract_title::after {
                content: "";
                position: absolute;
                top: 10px;
                left: 0;
                z-index: 1;
                border-radius: 50%;
                width: 16px;
                height: 16px;
                background: #0D53FC;
            }
        }

        .line_not {
            background: linear-gradient(
                    transparent 0%,
                    transparent 20px,
                    #FFFFFF 20px
            );
            background-size: 100% 100%;
        }

        .contract_info {
            width: 638px;
            background: #F9F9FB;
            border-radius: 16px;
            margin-left: auto;
            margin-top: 32px;

            .contract_head {
                position: relative;
                width: 100%;
                border-bottom: 2px solid #EAEAEA;

                p {
                    border-radius: 16px 0 0 0;
                    width: 160px;
                    height: 64px;
                    text-align: center;
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 64px;
                }
            }

            .red_head {
                p {
                    background: #E85858;
                }
            }

            .orange_head {
                p {
                    background: #EE9859;
                }
            }

            .contart_state {
                position: absolute;
                top: 12px;
                right: 32px;
                text-align: center;
                width: 96px;
                height: 36px;
                line-height: 36px;
                border-radius: 20px;
                border: 2px solid;
            }

            .green_state {
                border-color: #24AE71;
                color: #24AE71;
            }

            .orange_state {
                border-color: #EEB038;
                color: #EEB038;
            }

            .red_state {
                border-color: #E95859;
                color: #E95859;
            }

            .contract_msg_box {
                padding: 32px 32px 16px;

                .contract_msg {
                    p {
                        font-size: 24px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        color: #333333;
                        line-height: 28px;
                        margin-bottom: 16px;
                    }

                    .red_msg {
                        color: #E95859;
                    }
                }

                img {
                    width: 24px;
                    height: 24px;
                    display: block;
                    margin-left: auto;
                }

            }
        }
    }


    .contract_box::after {
        content: "";
        position: absolute;
        top: 58px;
        left: 38px;
        z-index: 0;
        width: 4px;
        height: calc(100% - 58px);
        background-image: linear-gradient(
                #F5F5F5 0%,
                #F5F5F5 50%,
                transparent 50%
        );
        background-size: 100% 16px;
        background-repeat: repeat-y;
    }

    .contract_not {
        width: 100%;
        padding: 48px 0 32px;

        .contract_not_img {
            width: 400px;
            height: 380px;
            display: block;
            margin: 0 auto;
        }

        p {
            font-size: 28px;
            font-family: Alata-Regular, Alata;
            color: $greyText;
            line-height: 33px;
            text-align: center;
        }

        .add_btn {
            width: 686px;
            height: 80px;
            background: #FFFFFF;
            border-radius: 16px;
            border: 2px solid #0D53FC;
            margin: 48px auto 0;
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: bold;
            color: #0D53FC;
            line-height: 28px;

            img {
                width: 32px;
                height: 32px;
                display: block;
                margin-right: 20px;
            }
        }
    }

    .bottom_btns {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 99;
        background: #FFFFFF;
        width: 100%;
        height: calc(112px + env(safe-area-inset-bottom));
        padding: 0 32px env(safe-area-inset-bottom);
        box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.03);

        button {
            width: 160px;
            height: 64px;
            background: #0D53FC;
            border-radius: 16px;
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 64px;
            text-align: center;
        }
    }
}
</style>
